<template>
  <div class="mt-8 w-full h-full bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Loyalty',
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('LoyaltyModule/fetchAllLevels');
    } catch (e) {
        // TODO
    }
  },
};
</script>

<style scoped>

</style>
